import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_48sb5c5tw7: FaireBrandEntity = {
  token: "b_48sb5c5tw7",
  type: "brand",
  name: "Adams Handmade Soap",
  avatarUrl:
    "https://cdn.faire.com/fastly/8bb7a1258f6c84ac1dbda2720fff686999bea41a464c1a2cf7dd77cecd3a39fa.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f500c6d2171dd70ddfadaec6d3815a1039f2388f3c7340afba8813f562ae3c53.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8bb7a1258f6c84ac1dbda2720fff686999bea41a464c1a2cf7dd77cecd3a39fa.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f500c6d2171dd70ddfadaec6d3815a1039f2388f3c7340afba8813f562ae3c53.jpeg",
  location: "Dunn, NC, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 350,
  isInsider: true,
  description:
    "Adams Handmade Soap's founder had a humble beginning and a simple vision: provide a creative product that is honest and in high demand. His ambition to make unique soaps with quality ingredients had its challenges, but to him this was non negotiable. With the help, and patience, of his wife, they started making soap in their 1000 square foot home in rural North Carolina. This type of story has been told before, but unlike many that are just stories created by marketing teams, this one is actually true. \n\nShortly after they started, they began being asked to make soap for businesses. At that point, they knew that this was the niche within the niche they desired to pursue. Over 15 years later, with a team of talented individuals, Adams Handmade Soap is known by many small businesses as their primary vendor for handmade soaps, bath bombs, lotions, and more.\n\nAdams Handmade Soap offers a vast variety of \"in house\" soaps and cosmetics or we can customize to your desired outcome. Please contact us for information on custom products.\n\nWe know there are many options and we are honored that you've considered us.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:58.333Z",
    importedBy: "entity-db-cli",
  },
};
